import apiClient from '../apiClient';

/**
 * Get all size guides (admin)
 * @returns {Promise<Array>} Array of size guides
 */
export const getAdminSizeGuides = async () => {
  try {
    const response = await apiClient.get('/admin/size-guides');
    return response.data;
  } catch (error) {
    console.error('Error fetching size guides:', error);
    throw error;
  }
};

/**
 * Create size guide
 * @param {Object} payload - Size guide data
 * @returns {Promise<Object>} Created size guide
 */
export const createSizeGuide = async (payload) => {
  try {
    const response = await apiClient.post('/admin/size-guides', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating size guide:', error);
    throw error;
  }
};

/**
 * Update size guide
 * @param {string} id - Size guide ID
 * @param {Object} payload - Size guide data
 * @returns {Promise<Object>} Updated size guide
 */
export const updateSizeGuide = async (id, payload) => {
  try {
    const response = await apiClient.put(`/admin/size-guides/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating size guide:', error);
    throw error;
  }
};

/**
 * Delete size guide
 * @param {string} id - Size guide ID
 * @returns {Promise<void>}
 */
export const deleteSizeGuide = async (id) => {
  try {
    await apiClient.delete(`/admin/size-guides/${id}`);
  } catch (error) {
    console.error('Error deleting size guide:', error);
    throw error;
  }
};
